import { getPortalActivityList } from '@/api/promoActivity';
export default function useActivityList(scene) {
  console.log('scene: ', scene);
  // 获取活动列表
  const pointShopUrl = import.meta.env.VITE_APP_DOMAIN_POINT;
  const activityList = ref([]);
  function getActivityList() {
    getPortalActivityList().then(res => {
      activityList.value = res.data
        .filter(item => {
          let imgs = [];
          const img = '';
          try {
            imgs = JSON.parse(item.picJson);
            if (imgs.every(item => item.url)) {
              return true;
            }
          } catch (error) {
            imgs = [];
            return false;
          }
        })
        .map(item => {
          let imgs = [];
          let img = '';
          try {
            imgs = JSON.parse(item.picJson);
            img = imgs.find(item => item.key == scene)?.url ?? '';
          } catch (error) {
            imgs = [];
          }
          return {
            ...item,
            img,
          };
        });
      console.log('activityList.value: ', activityList.value);
    });
  }

  function goActivityDetail(activityId) {
    console.log('activityId: ', activityId);
    // router.push({
    //   path: '/point/sale/' + activityId,
    // });
    window.location.href = pointShopUrl + '/point/sale/' + activityId;
  }

  return {
    activityList,
    getActivityList,
    goActivityDetail,
  };
}
